import Request from './request'
export default class CustomerReviewService {
  static async viewAppUserReview(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Stations/user/viewAppUserReview',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }
  static async viewStationSchedule(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Stations/user/viewStationSchedule',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }
  static async viewStationCustomers(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Stations/user/viewStationCustomerRecord',
        data: data
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(result)
        } else {
          return resolve(result)
        }
      })
    })
  }
}
